import { render } from "./cupom.vue?vue&type=template&id=aef891a0"
import script from "./cupom.vue?vue&type=script&lang=js"
export * from "./cupom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__